import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Projects from "@/pages/Projects";

export const Route = createFileRoute("/en/about-qbd/projects/")({
  head: () => buildRouteHead("/en/about-qbd/projects"),
  component: Projects,
});

